import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderTabs', {
  orderNumber: 'Orden N° {{orderNumber}}'
});

i18next.addResources('pt_PT', 'OrderTabs', {
  orderNumber: 'Pedido N° {{orderNumber}}'
});
